<template>
  <footer class="footer">
        <div class="container">
            <div class="footer__body">
                <router-link to="/" class="footer__logo">
                    <v-lazy-image src="/static/img/logo-footer.svg" alt="Logo footer" class="footer__logo__img" />
                </router-link>

                <nav class="footer__nav">
                    <div class="footer__nav__block">
                        <h3 class="footer__nav__title">SERVICE</h3>

                        <div class="footer__nav__list">
                            <router-link class="footer__nav__list__item" to="/advertisers"
                                         @click.native="toggleBottomMenu">Advertisers
                            </router-link>
                            <router-link class="footer__nav__list__item" to="/publishers"
                                         @click.native="toggleBottomMenu">Publishers
                            </router-link>
                            <router-link class="footer__nav__list__item" to="/signup">Create a campaign</router-link>
                        </div>
                    </div>

                    <div class="footer__nav__block">
                        <h3 class="footer__nav__title">COMPANY</h3>

                        <div class="footer__nav__list">
                          <router-link class="footer__nav__list__item" to="/news">News</router-link>
                          <router-link class="footer__nav__list__item" to="/help">Help</router-link>
                        </div>
                    </div>

                    <div class="footer__nav__block">
                        <h3 class="footer__nav__title">LEARN MORE</h3>

                        <div class="footer__nav__list">
                          <a class="footer__nav__list__item" href="/terms_of_service" target="_blank">Terms Of service</a >
                          <a class="footer__nav__list__item" href="/privacy_policy" target="_blank">Privacy Policy</a>
                          <a class="footer__nav__list__item" href="/cookie_policy" target="_blank">Cookie Policy</a>
                          <a class="footer__nav__list__item" href="/refund_policy" target="_blank">Refund Policy</a>
                        </div>
                    </div>

                    <div class="footer__nav__block footer__nav__block--mob-fullw">
                        <h3 class="footer__nav__title">CONTACTS</h3>

                        <div class="footer__nav__list">
                            <a href="#" class="footer__nav__list__item footer__nav__list__item--mbs">(852) 8199 9302</a>
                            <a href="mailto:bd@adoperator.org" class="footer__nav__list__item footer__nav__list__item--mbs">bd@adoperator.org</a>
                        </div>

                        <address class="footer__nav__address">Smart Vast Ltd.  Room 2303, New Tech Plaza<br />34 Tai Yau Street, San Po Kong Kowloon, Hong Kong </address>

                        <div class="footer__socials">
                            <a href="//www.facebook.com/AdOperator/" target="_blank" class="footer__socials__item">
                                <v-lazy-image src="/static/img/footer-soc-01.svg" alt="facebook" class="footer__socials__item__img" />
                            </a>
                            <a href="//www.linkedin.com/company/adoperator" target="_blank" class="footer__socials__item">
                                <v-lazy-image src="/static/img/footer-soc-02.svg" alt="linkedin" class="footer__socials__item__img" />
                            </a>
                            <a href="//www.instagram.com/adoperator/" target="_blank" class="footer__socials__item">
                                <v-lazy-image src="/static/img/footer-soc-03.svg" alt="instagram" class="footer__socials__item__img" />
                            </a>
                            <a href="//twitter.com/Adoperator1" target="_blank" class="footer__socials__item">
                                <v-lazy-image src="/static/img/footer-soc-04.svg" alt="twitter" class="footer__socials__item__img" />
                            </a>
                        </div>
                    </div>
                </nav>
                <a target="_blank" href="//www.google.com/maps/place/2303,+New+Tech+Plaza,+34+Tai+Yau+St,+San+Po+Kong,+%D0%93%D0%BE%D0%BD%D0%BA%D0%BE%D0%BD%D0%B3/@22.3366342,114.1949724,17z/data=!3m1!4b1!4m5!3m4!1s0x340406d735887a05:0x22b46521c9b8dc7a!8m2!3d22.3366342!4d114.1971611">
                    <v-lazy-image src="/static/img/map.png" alt="map" class="footer__map" />
                </a>
            </div>
        </div>

        <div class="footer__copyright">
            <div class="container">
                <div class="footer__copyright__text">© 2018 Ad Operator Inc. All rights reserved. </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      logget: this.$store.getters.isAuthenticated
    }
  },
  methods: {
    toggleBottomMenu (event) {
      if (this.$route.name === 'Home') {
        if (window.$(event.target).attr('href') === '/advertisers') {
          window.$('html,body').scrollTop(window.$('#advertisers').offset().top - 40)
        }
        if (window.$(event.target).attr('href') === '/publishers') {
          window.$('html,body').scrollTop(window.$('#publishers').offset().top - 40)
        }
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/front/footer.vue